export default "__VITE_PUBLIC_ASSET__10d95a9c__"